import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { UserService } from 'src/app/services/management/user/user.service';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  constructor(private fb: FormBuilder, private userService: UserService) { }
  ngOnInit(): void {
    this.registerForm = this.fb.group({
      name: ['', [Validators.required]],
      surname: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required]],
      password: ['', [Validators.required, this.confirmPasswordValidator]],
      confirmPassword: ['', [Validators.required, this.confirmPasswordValidator]]

    });
  }
  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
  const pass = group.controls.password.value;
  const confirmPass = group.controls.confirmPassword.value;

  return pass === confirmPass ? null : { notSame: true };
}
  submitForm() {

    if (this.registerForm.valid) {
      this.userService.register({
        name: this.registerForm.controls.name.value,
        phone: this.registerForm.controls.phone.value,
        surname: this.registerForm.controls.surname.value,
        email: this.registerForm.controls.email.value,
        password: this.registerForm.controls.password.value
      });
    } else {
      console.log('dfdfsdfsdf');
    }
  }
  confirmPasswordValidator(control: FormControl) {
    const parent = control.parent as FormGroup;
    if (parent === undefined) {
      return null;
    }
    const password = parent.controls.password;
    const cpassword = parent.controls.confirmPassword;
    if ( password.value !== cpassword.value) {
      return {
        passwordMissmatch: {
          password: `"${password}" not the same as "${cpassword}"`
        }
      };
    }
    return null;
  }
  updatepasswordValidation(control: string) {
    this.registerForm.controls[control].updateValueAndValidity();
  }
}
